// extracted by mini-css-extract-plugin
export default {"logo":"SovrynLogo_logo__byk29","link":"SovrynLogo_link__zOCJk"};